class Intro{
    constructor(){
        this.context = null;
        this.pageActive = {};




        TweenMax.to('.circle1',0, {scale:0,opacity:1,ease:Power0.easeNone,onComplete:function(){
            TweenMax.to('.circle1', 3, {scale:2, opacity:0, repeat:-1,ease:Power0.easeNone});
        }});

        TweenMax.to('.circle2',0, {delay:1.5,scale:0,opacity:1,ease:Power0.easeNone,onComplete:function(){
            TweenMax.to('.circle2', 3, {scale:2, opacity:0, repeat:-1,ease:Power0.easeNone});
        }});


       TweenMax.to('.obj0-box', 3, {delay: 2, top: -5, yoyo: true, repeat: -1, ease:Power0.easeNone});
    }
    
    start(page){
        this.pageActive[page] = true;
        this[page]();
        this.context.removeClass('animate-out');
        
    }
    
    reset(page){
        this.pageActive[page] = false;
        this.context.removeClass('animate-in');
        this.context.addClass('animate-out');

    }
    
    intro1(){
        this.context = $('.section-page__intro');
        this.context.addClass('animate-intro');

    }

}

export default Intro;


// WEBPACK FOOTER //
// ./history/2017/170913_taecheon/_src/js/page/intro.js